import React, { useEffect } from 'react';
import ExamInsightsPage from '../../features/specialty/editorial/ExamInsightsPage';

export default function LnatInsightsRoute() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <ExamInsightsPage />;
}
